import { useCallback, useEffect, useState } from 'react';

import {
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';

import { useTranslation } from 'react-i18next';

import Link from 'next/link';
import { useRouter } from 'next/router';

import { ChevronDownIcon } from '@chakra-ui/icons';

import { NAV_ITEMS } from 'constants/navigation';

import { useReduxDispatch } from 'hooks/redux/useReduxDispatch';

import AccessControl from 'components/utils/AccesControl';

import { authActions } from 'store/slices/auth';

const NavMenu = () => {
  const router = useRouter();
  const reduxDispatch = useReduxDispatch();
  const { t } = useTranslation(['navigation', 'common']);
  const [activeItem, setActiveItem] = useState<string>('menu.welcome');

  useEffect(() => {
    NAV_ITEMS.forEach(item => {
      if (router.pathname === item.href) {
        setActiveItem(() => item.label);
      }
    });
  }, [router]);

  const handleLogout = useCallback(() => {
    reduxDispatch(authActions.logoutRequest());
  }, [reduxDispatch]);

  return (
    <Menu>
      <MenuButton
        _hover={{ textDecoration: 'underline' }}
        background="secondary"
        border="1px solid transparent"
        color="white"
      >
        {t(activeItem)}
        <ChevronDownIcon ml={2} />
      </MenuButton>
      <MenuList>
        {NAV_ITEMS.map(item => (
          <AccessControl
            allowRoles={item.access}
            key={item.label}
            permission={item.permission}
          >
            <Link href={item.href} passHref>
              <MenuItem>{t(item.label)}</MenuItem>
            </Link>
          </AccessControl>
        ))}
        <MenuDivider />
        <MenuItem onClick={handleLogout}>{t('common:generic.logout')}</MenuItem>
      </MenuList>
    </Menu>
  );
};

export default NavMenu;
